import React, { Component } from "react";
import { CustomInput, Input } from "reactstrap";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import classnames from "classnames";
import style from "./OrderQuantityAssignment.module.scss";
import { Field } from "../Order/Field/Field";
import * as OrderItemUI from "../../Order/Item";
import { OrderDayStatus } from "../../../utils/Order/Order";

const ItemRow = ({ account, selectedDate, id, actions, title = "", ...props }) => {
  const dayInfo = account.days.find((d) => d.date === selectedDate);

  const enabled = [OrderDayStatus.LOCKED, OrderDayStatus.BOOKED].indexOf(dayInfo.status) < 0;

  return (
    <React.Fragment>
      {title !== "" ? <div>{title}</div> : null}
      <div className={`${style.item} ${enabled ? style.active : ""}`}>
        <div className={style.fields}>
          <Field label="Assigned Qty" error={dayInfo["error_assignedQty"]}>
            <NumberFormatInput
              type="text"
              customInput={Input}
              value={dayInfo.assignedQty}
              disabled={!enabled}
              invalid={!!dayInfo["error_assignedQty"]}
              onValueChange={(e) => actions.change(id, "assignedQty", e.value)}
              dataTypeDecimalName="quantity"
              placeholder="Assigned Qty"
            />
          </Field>
        </div>
        <AccountDetail account={account} dayInfo={dayInfo} />
      </div>
    </React.Fragment>
  );
};

export const AccountDetail = ({ account, dayInfo }) => {
  return (
    <div>
      <div>
        Account #<b>{account.accountNumber}</b>
        {" ("}
        {account.accountName}
        {")"}
      </div>

      <hr className={style.line} />

      <div className={style.bottomRow}>
        <div style={{ display: "inline-block", verticalAlign: "middle" }}>
          {`Day status: ${dayInfo.status}  |  Asked: ${account.askedQty}  |  Total assigned: ${account.totalAssignedQty}  |  Total booked: ${account.totalBookedQty}`}
        </div>
      </div>
    </div>
  );
};

export default ItemRow;
